module.exports = __webpack_public_path__ + "static/beverly-hills-14abd9c21b55ac88bb63f2c104d3c5f3.png";